// Hora de Cabo Verde (UTC−1, sem horário de verão), independente do fuso do browser.
//
// A API devolve ISO com "Z" em dois sentidos diferentes:
//  (A) hora de parede de CV marcada com Z — datas escritas por pessoas (datas de
//      eventos, prazos, validades). Mostrar tal e qual: fmtParede (timeZone 'UTC').
//      Comparar com nowCv(), que é o «agora em CV» na mesma convenção.
//  (B) instantes reais UTC — created_at, pagamentos, transacções. Mostrar com
//      fmtInstante (timeZone CV) e agrupar por dia com cvDayKey.

export const CV_TZ = 'Atlantic/Cape_Verde';

type DataEntrada = string | number | Date | null | undefined;

const toDate = (v: DataEntrada): Date | null => {
  if (v === null || v === undefined || v === '') return null;
  const d = v instanceof Date ? v : new Date(v);
  return isNaN(d.getTime()) ? null : d;
};

/** «Agora em CV» na convenção (A): comparar com datas de parede marcadas com Z. */
export const nowCv = (): Date => new Date(Date.now() - 3600e3);

/** Dia de hoje em CV, 'YYYY-MM-DD'. */
export const todayCv = (): string => new Date().toLocaleDateString('en-CA', { timeZone: CV_TZ });

/** Formata uma data (A) — hora de parede de CV marcada com Z — tal e qual. */
export const fmtParede = (
  iso: DataEntrada,
  opts: Intl.DateTimeFormatOptions = {},
  locale = 'pt-CV',
): string => {
  const d = toDate(iso);
  return d ? d.toLocaleString(locale, { ...opts, timeZone: 'UTC' }) : '';
};

/** Formata um instante (B) real UTC na hora de CV. */
export const fmtInstante = (
  iso: DataEntrada,
  opts: Intl.DateTimeFormatOptions = {},
  locale = 'pt-CV',
): string => {
  const d = toDate(iso);
  return d ? d.toLocaleString(locale, { ...opts, timeZone: CV_TZ }) : '';
};

/** Dia civil em CV ('YYYY-MM-DD') de um instante (B). */
export const cvDayKey = (iso: DataEntrada): string => {
  const d = toDate(iso);
  return d ? d.toLocaleDateString('en-CA', { timeZone: CV_TZ }) : '';
};
